<template>
    <div>
        <Backlink :back="{ name: 'clients.view', params: { id: model.client_id } }" />
        <h2>Informations sur le model</h2>
        <section-container>
            <p class="text-muted">{{ model.client?.nom }} {{ model.client?.prenoms }} [{{ GENRE[model.client?.genre] }}]
            </p>
        </section-container>
        <div class="row">
            <div class="col">
                <div class="card">
                    <div class="row">
                        <div class="col">
                            <button v-if="model.status == modelStatus.PENDING" class="btn btn-primary m-1"
                                data-bs-toggle="modal" data-bs-target="#modelChangeStatus"
                                @click="askStatusChange('approved')">Approuver</button>
                            <button v-if="model.status == modelStatus.APPROVED" class="btn btn-primary m-1"
                                data-bs-toggle="modal" data-bs-target="#modelChangeStatus"
                                @click="askStatusChange('rejected')">Refuser</button>
                            <button v-if="model.status == modelStatus.APPROVED" class="btn btn-primary m-1"
                                data-bs-toggle="modal" data-bs-target="#modelChangeStatus"
                                @click="askStatusChange('done')">Terminer</button>
                            <button v-if="model.status == modelStatus.DONE" class="btn btn-primary m-1"
                                data-bs-toggle="modal" data-bs-target="#modelChangeStatus"
                                @click="askStatusChange('delivered')">Livrer</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal m-title="Changer de status" idx="modelChangeStatus" :dismiss="dismissStatusEditing">
            <ModelChangeStatusForm :client_id="model.client_id" :item="itemStatusEditing" @edit="statusChanged"
                @cancel="dismissStatusEditing++" />
        </modal>
        <div class="row">
            <div>
                <div class="d-flex my-2 justify-content-between">
                    <div>
                        <p class="fw-bold">{{
                            model.label }}</p>
                    </div>
                    <div>
                        <button class="btn btn-secondary"
                            @click="$router.push({ name: 'models.edit', params: { client_id: model.client_id, id: model.id } })">
                            <span><i class="bi bi-pencil-square me-1"></i></span>
                            Modifier</button>
                    </div>
                </div>
            </div>
            <p class="card-text"> <span class="text-muted text-sm">Statut: </span> <span
                    :class="['badge', statusInfo[model.status]?.class]"> {{ statusInfo[model.status]?.label }}</span>
            </p>

            <p class="card-text"> <span class="text-muted text-sm">Date de création:</span> {{
                formatDate(model.created_at)
            }}</p>



            <p v-if="model.delivery_date" class="card-text"> <span class="text-muted text-sm">Date de livraison:</span>
                {{
                    formatDate(model.delivery_date)
                }}</p>
            <p v-if="model.next_rdv?.length && model.status != modelStatus.DELIVERED" class="card-text"> <span
                    class="text-muted text-sm">Prochain RDV:</span>
                {{
                    formatDate(model.next_rdv)
                }}</p>
            <div v-if="model.image_path">
                <div class="card">
                    <div class="card-body">
                        <img :src="$api.defaults.assetsBaseURL + model.image_path" alt="Model Image"
                            class="img-fluid" />
                    </div>
                </div>
            </div>
            <div class="card-text mt-2">
                <h5>Description:</h5>
                <p>{{ model.commentaire }}</p>

            </div>
        </div>


        <section-container marquage 
        v-if="userStore.$state.user?.permissionsList?.includes('manage_paiements')"
        >
            <div class="d-flex justify-content-between align-items-center mt-4">
                <h3>Paiements associés</h3>
                <div>
                    <button class="btn btn-primary ms-auto" data-bs-toggle="modal" data-bs-target="#addPaiement">
                        Ajouter un
                        paiement</button>

                    <modal m-title="Ajout de paiement" idx="addPaiement" :dismiss="dismissAddPaiement">
                        <PaiementForm :model_id="id" @save="paiementSaved" @edit="paiementSaved" />
                    </modal>

                </div>
            </div>

            <div class="row">
                <div class="col-12">

                    <small class="text-muted">Coût du modèle:</small> <span class="fw-bold">{{
                        formatAmount(model.price, 'XOF') }}</span> <br />
                    <small class="text-muted">Total payé:</small> <span class="fw-bold">{{ formatAmount(totalPaye,
                        'XOF')
                        }}</span> <br />
                    <small v-if="resteAPyaer" class="text-muted">Reste à payer:</small> <span
                        :class="['fw-bold', totalPaye > 0 ? 'text-danger' : '']">{{ formatAmount(resteAPyaer, 'XOF')
                        }}</span> <br />
                </div>
            </div>

            <div class="table-responsive" v-if="model.paiements && model.paiements.length">
                <!-- Desktop: table only visible on large screens and up -->
                <div class="table-responsive d-none d-md-block">
                    <table id="paiementsTable" class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Montant</th>
                                <th>Méthode</th>
                                <th class="text-end">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="pay in model.paiements" :key="pay.id">
                                <td>{{ formatDate(pay.date_paiement) }}</td>
                                <td>{{ formatAmount(pay.montant) }}</td>
                                <td>{{ pay.methode.toUpperCase() }}</td>
                                <td class="text-end">
                                    <button class="btn btn-warning" data-bs-toggle="modal"
                                        :data-bs-target="'#editPaiementLg' + pay.id">
                                        <span><i class="bi bi-pencil-square me-1"></i></span>
                                        Modifier
                                    </button>
                                    <modal :m-title="'Modifier le paiement ' + pay.id" :idx="'editPaiementLg' + pay.id"
                                        :dismiss="dismissAddPaiement">
                                        <PaiementForm :model_id="id" :item="pay" :paiement_id="pay.id"
                                            @save="paiementSaved" @edit="paiementSaved" />
                                    </modal>
                                    <button class="btn btn-danger m-1" data-bs-toggle="modal"
                                        :data-bs-target="'#deletePaiementLg' + pay.id">
                                        <span><i class="bi bi-trash me-1"></i></span>
                                        Supprimer
                                    </button>
                                    <modal :m-title="'Supprimer le paiement de ' + formatAmount(pay.montant)"
                                        :idx="'deletePaiementLg' + pay.id" :dismiss="dismissDeletePaiement">
                                        <div class="text-center">
                                            <p class="text-danger">Êtes-vous sûr de vouloir supprimer ce paiement ?</p>
                                            <button class="btn btn-danger m-1" @click="deletePaiement(pay.id)">Oui,
                                                supprimer</button>
                                            <button class="btn btn-secondary" @click="dismissDeletePaiement++">Non,
                                                annuler</button>
                                        </div>

                                    </modal>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Mobile: stacked list/cards visible only on small screens -->
                <div class="d-block d-md-none mt-2">
                    <div class="list-group">
                        <div class="list-group-item" v-for="pay in model.paiements" :key="'mobile-' + pay.id">
                            <div class="d-flex w-100 justify-content-between align-items-start">
                                <div>
                                    <h6 class="mb-1">{{ formatAmount(pay.montant) }}</h6>
                                    <small class="text-muted">{{ pay.methode.toUpperCase() }}</small>
                                </div>
                                <small class="text-muted">{{ formatDate(pay.date_paiement) }}</small>
                            </div>
                            <div class="mt-2 d-flex gap-2 justify-content-end">
                                <button class="btn btn-sm btn-warning" data-bs-toggle="modal"
                                    :data-bs-target="'#editPaiementSm' + pay.id">
                                    <i class="bi bi-pencil-square me-1"></i>Modifier
                                </button>
                                <modal :m-title="'Modifier le paiement ' + pay.id" :idx="'editPaiementSm' + pay.id"
                                    :dismiss="dismissAddPaiement">
                                    <PaiementForm :model_id="id" :item="pay" :paiement_id="pay.id" @save="paiementSaved"
                                        @edit="paiementSaved" />
                                </modal>
                                <button class="btn btn-sm btn-danger" data-bs-toggle="modal"
                                    :data-bs-target="'#deletePaiement' + pay.id">
                                    <i class="bi bi-trash me-1"></i>Supprimer
                                </button>
                                <modal :m-title="'Supprimer le paiement de ' + formatAmount(pay.montant)"
                                    :idx="'deletePaiement' + pay.id" :dismiss="dismissDeletePaiement">
                                    <div class="text-center">
                                        <p class="text-danger">Êtes-vous sûr de vouloir supprimer ce paiement ?</p>
                                        <button class="btn btn-danger m-1" @click="deletePaiement(pay.id)">Oui,
                                            supprimer</button>
                                        <button class="btn btn-secondary" @click="dismissDeletePaiement++">Non,
                                            annuler</button>
                                    </div>

                                </modal>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else> ><p class="text-muted">Le client n'a encore fait aucun paiement.</p></div>
        </section-container>

        <section-container marquage>
            <div class="d-flex justify-content-between align-items-center mt-4">
                <h3>Tissus</h3>
                <div>
                    <button class="btn btn-primary ms-auto"
                        @click="$router.push({ name: 'tissus.create', params: { model_id: id } })">
                        Ajouter tissu</button>
                </div>
            </div>

            <div class="table-responsive" v-if="model.tissus && model.tissus.length">
                <!-- Desktop: table only visible on large screens and up -->
                <div class="table-responsive d-none d-lg-block">
                    <table id="paiementsTable" class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th>Label</th>
                                <th>Color</th>
                                <th>Quality</th>
                                <th>Quantity</th>
                                <th class="text-end">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="tissu in model.tissus" :key="tissu.id">
                                <td>{{ tissu.label }}</td>
                                <td>{{ tissu.color }}</td>
                                <td>{{ tissu.quality }}</td>
                                <td>{{ tissu.quantity }}</td>
                                <td class="text-end">
                                    <button class="btn btn-primary m-1"
                                        @click="$router.push({ name: 'tissus.view', params: { id: tissu.id } })">
                                        <i class="bi bi-eye me-1"></i>Voir
                                    </button>
                                    <button class="btn btn-warning"
                                        @click="$router.push({ name: 'tissus.edit', params: { model_id: tissu.style_id, id: tissu.id } })">
                                        <span><i class="bi bi-pencil-square me-1"></i></span>
                                        Modifier
                                    </button>
                                    <button class="btn btn-danger m-1" data-bs-toggle="modal"
                                        :data-bs-target="'#deleteTissu' + tissu.id">
                                        <span><i class="bi bi-trash me-1"></i></span>
                                        Supprimer
                                    </button>
                                    <modal :m-title="'Supprimer le tissu '" :idx="'deleteTissu' + tissu.id"
                                        :dismiss="dismissDeleteTissu">
                                        <div class="text-center">
                                            <p class="text-danger">Êtes-vous sûr de vouloir supprimer ce tissu ?</p>
                                            <button class="btn btn-danger m-1" @click="deleteTissu(tissu.id)">Oui,
                                                supprimer</button>
                                            <button class="btn btn-secondary" @click="dismissDeleteTissu++">Non,
                                                annuler</button>
                                        </div>

                                    </modal>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Mobile: stacked list/cards visible only on small screens -->
                <div class="d-block d-lg-none mt-2">
                    <div class="list-group">
                        <div class="list-group-item" v-for="tissu in model.tissus" :key="'mobile-' + tissu.id">
                            <div class="d-flex w-100 justify-content-between align-items-start">
                                <div>
                                    <h6 class="mb-1">{{ tissu.label }}</h6>
                                    <small class="text-muted">{{ tissu.color }}</small>
                                </div>
                                <small class="text-muted">{{ tissu.quality }} ({{ tissu.quantity }})</small>
                            </div>
                            <div class="mt-2 d-flex gap-2 justify-content-end">
                                <button class="btn btn-sm btn-primary"
                                    @click="$router.push({ name: 'tissus.view', params: { id: tissu.id } })">
                                    <i class="bi bi-eye me-1"></i>Voir
                                </button>
                                <button class="btn btn-sm btn-warning"
                                    @click="$router.push({ name: 'tissus.edit', params: { model_id: tissu.style_id, id: tissu.id } })">
                                    <i class="bi bi-pencil-square me-1"></i>Modifier
                                </button>
                                <button class="btn btn-sm btn-danger" data-bs-toggle="modal"
                                    :data-bs-target="'#deleteTissuSm' + tissu.id">
                                    <i class="bi bi-trash me-1"></i>Supprimer
                                </button>
                                <modal :m-title="'Supprimer le tissu'" :idx="'deleteTissuSm' + tissu.id"
                                    :dismiss="dismissDeleteTissu">
                                    <div class="text-center">
                                        <p class="text-danger">Êtes-vous sûr de vouloir supprimer ce tissu ?</p>
                                        <button class="btn btn-danger m-1" @click="deleteTissu(tissu.id)">Oui,
                                            supprimer</button>
                                        <button class="btn btn-secondary" @click="dismissDeleteTissu++">Non,
                                            annuler</button>
                                    </div>

                                </modal>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else><p class="text-muted"> Aucun tissu choisi.</p></div>
        </section-container>
    </div>
</template>


<script>

import { modelStatusInfo, ModelStatus } from '@/enums/ModelStatus';
import dateFormater from '@/helpers/dateFormater';
import amountFormater from '@/helpers/amountFormater';
import { HumanGenre } from '@/enums/HumanGenre';

import Modal from '@/components/modals/Modal.vue';
import PaiementForm from '@/components/forms/PaiementForm.vue';
import ModelChangeStatusForm from '@/components/forms/ModelChangeStatusForm.vue';
import Backlink from '@/components/partials/Backlink.vue';
import SectionContainer from '@/components/elements/SectionContainer.vue';
import { useUserStore } from '@/store/userStore';

export default {
    name: 'ModelView',
    props: {
        id: {
            type: [String, Number],
            required: true,
        },
    },
    components: {
        Modal,
        PaiementForm,
        ModelChangeStatusForm,
        Backlink,
        SectionContainer
    },
    data() {
        return {
            model: {},
            statusInfo: modelStatusInfo,
            modelStatus: ModelStatus,
            GENRE: HumanGenre,
            dismissAddPaiement: 0,
            dismissDeletePaiement: 0,
            dismissStatusEditing: 0,
            dismissDeleteTissu: 0,
            itemStatusEditing: {}
        }
    },
    computed: {
        totalPaye() {
            return this.model?.paiements?.reduce((acc, paiement) => acc + paiement.montant, 0) || 0;
        },
        resteAPyaer() {
            return this.model.price - this.totalPaye
        },
        userStore: ()=>useUserStore()
    },
    methods: {
        ...dateFormater,
        ...amountFormater,
        getModel() {
            // Fetch model data based on this.id
            this.$api.get(`/styles/${this.id}`)
                .then(response => {
                    // Handle the response data
                    this.model = response.data.data;
                })
                .catch(error => {
                    console.error('There was an error fetching the model!', error);
                });
        },
        paiementSaved() {
            this.dismissAddPaiement++;
            this.getModel();
        },
        statusChanged() {
            this.dismissStatusEditing++;
            this.getModel();
        },
        deletePaiement(id) {
            // Delete paiement based on this.id
            this.$api.delete(`/paiements/${id}`)
                .then(() => {
                    // Handle the response data
                    this.dismissDeletePaiement++;
                    this.getModel();
                })
                .catch(error => {
                    console.error('There was an error deleting the paiement!', error);
                });
        },
        deleteTissu(id) {
            // Delete paiement based on this.id
            this.$api.delete(`/tissus/${id}`)
                .then(() => {
                    // Handle the response data
                    this.dismissDeleteTissu++;
                    this.getModel();
                })
                .catch(error => {
                    console.error('There was an error deleting the paiement!', error);
                });
        },

        askStatusChange(status) {
            this.itemStatusEditing.id = this.model.id;
            this.itemStatusEditing.status = status;
        },

    },

    created() {
        this.getModel();
    }
}

</script>